import { useState } from 'react';
import { api } from '../lib/api.js';

export default function ImportGeocoding({ base, recordId, initialQuery, disabled, onSelect }) {
  const [query, setQuery] = useState(initialQuery ?? '');
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  return <section aria-label={`Address search for record ${recordId}`}>
    <label>Search facility address<input value={query} disabled={disabled||busy} maxLength={200} onChange={(e)=>{setQuery(e.target.value);setResults(null);}} /></label>
    <button className="btn" type="button" disabled={disabled||busy||query.trim().length<4} onClick={async()=>{
      setBusy(true);setError(null);setResults(null);
      try { const r=await api(`${base}/geocode`,{method:'POST',body:{query:query.trim()}}); setResults({...r,query:query.trim()}); }
      catch(e){setError(e.message);} finally{setBusy(false);}
    }}>{busy?'Searching…':'Find locations'}</button>
    {error&&<p role="alert">{error}</p>}
    {results&&<>
      <p className="muted">{results.attribution}</p>
      {!results.candidates.length?<p>No locations found. Add a city, province/state or postal code and try again.</p>:<>
        <p>Select a location after checking the address and coordinates.</p>
        {results.candidates.map((c,i)=><div key={i} style={{marginBottom:8}}>
          <span>{c.label} · {c.lat}, {c.lon}</span>{' '}
          <button type="button" className="btn" disabled={disabled} onClick={()=>{onSelect({...c,query:results.query});setResults(null);}}>Use this location</button>
        </div>)}
      </>}
    </>}
  </section>;
}
